import { render, staticRenderFns } from "./SPKPR.vue?vue&type=template&id=532f376b"
import script from "./SPKPR.vue?vue&type=script&lang=js"
export * from "./SPKPR.vue?vue&type=script&lang=js"
import style0 from "./SPKPR.vue?vue&type=style&index=0&id=532f376b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports